import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let TreeComp;

class Tree extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: TreeComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/lyte-components/tree-comp" */
      "../../../components/javascript/lyte-components/tree-comp").then(function(res) {
        TreeComp = res.TreeComp;
      })
    );

    
;
  }
}

export { Tree };
